/**
 * Constants relating to the Peer model.
 */
export const PEER = {
  TRICKLE_ICE: {
    FULL: 'FULL',
    HALF: 'HALF',
    NONE: 'NONE'
  },
  // Defined by the RTCPeerConnection.iceGatheringState spec.
  ICE_GATHERING_STATE: {
    NEW: 'new',
    GATHERING: 'gathering',
    COMPLETE: 'complete'
  },
  ENDPOINT: {
    LOCAL: 'local',
    REMOTE: 'remote'
  },
  SDP_SEMANTICS: {
    PLAN_B: 'plan-b',
    UNIFIED_PLAN: 'unified-plan'
  }
}

/**
 * SDP constants for media direction.
 * @type {Object}
 */
export const MEDIA_DIR = {
  INACTIVE: 'inactive',
  SEND_ONLY: 'sendonly',
  RECV_ONLY: 'recvonly',
  SEND_RECV: 'sendrecv'
}

/**
 * Reasons for calling the Ice Collection Check function.
 * @name ICE_COLLECTION_CHECK_REASONS
 */
export const ICE_COLLECTION_CHECK_REASONS = {
  ICE_GATHERING_STATE_CHANGE: 'IceGatheringStateChanged',
  NEW_CANDIDATE: 'NewCandidate',
  SCHEDULED: 'Scheduled'
}

/**
 * Result types for the Ice Collection Check Function.
 * @name ICE_COLLECTION_RESULT_TYPES
 */
export const ICE_COLLECTION_RESULT_TYPES = {
  START_CALL: 'StartCall',
  WAIT: 'Wait',
  ERROR: 'Error'
}
